import React from 'react';
import { CheckIcon } from 'lucide-react';
import { requirements } from '../data/seminar';
export function WhoSection() {
  return <section className="navy-texture w-full py-20 sm:py-28" data-id="element-109" data-mp="2d29809inqupc">
      <div className="mx-auto max-w-3xl px-6 text-center" data-id="element-110" data-mp="1z3jcuzfef53m">
        <span className="section-label" data-id="element-111" data-mp="1z5452ie8qbyb">Requisitos</span>
        <h2 className="mt-5 font-serif text-4xl font-light leading-tight text-white sm:text-5xl" data-id="element-112" data-mp="2411ncu92dsdq">
          ¿Quién puede venir?
        </h2>
        <div className="mx-auto mt-7 h-px w-16 bg-gold" aria-hidden="true" data-id="element-113" data-mp="1pb3va380kij9" />

        <ul className="mx-auto mt-12 max-w-xl space-y-3 text-left" data-id="element-114" data-mp="1u5hrg7ui2toz">
          {requirements.map(item => <li key={item} className="flex items-start gap-4 rounded-xl bg-white/[0.06] px-6 py-5" data-id="element-115" data-mp="1ged0du5779q9">
              <CheckIcon className="mt-1 h-5 w-5 shrink-0 text-gold" strokeWidth={1.5} aria-hidden="true" data-id="element-116" data-mp="16em1zhdioakw" />
              <span className="font-sans text-base font-light leading-relaxed text-white sm:text-lg" data-id="element-117" data-mp="1bf9uk7he8zh8">
                {item}
              </span>
            </li>)}
        </ul>

        <p className="mt-10 font-serif text-2xl font-light italic text-gold sm:text-3xl" data-id="element-118" data-mp="2pbfvgg9bzdyr">
          Con SSN o ITIN, todos son bienvenidos
        </p>
      </div>
    </section>;
}